import { GET_ESTADOS_ERROR, GET_ESTADOS_LOADING, GET_ESTADOS_SUCCESS } from "./estado_types"
import { CREATE_ESTADOS_ERROR, CREATE_ESTADOS_LOADING, CREATE_ESTADOS_SUCCESS } from "./estado_types"
import { UPDATE_ESTADOS_ERROR, UPDATE_ESTADOS_LOADING, UPDATE_ESTADOS_SUCCESS } from "./estado_types"
import { DELETE_ESTADOS_ERROR, DELETE_ESTADOS_LOADING, DELETE_ESTADOS_SUCCESS } from "./estado_types"


let initialState = {
    loading: false,
    error: false,
    data: []
}

export const estadoReducer = (state=initialState, action)=>{
    const {type, payload} = action
    switch(type){
        case GET_ESTADOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case GET_ESTADOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, dataestado: payload
            }
        }
        case GET_ESTADOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case CREATE_ESTADOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case CREATE_ESTADOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case CREATE_ESTADOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case UPDATE_ESTADOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case UPDATE_ESTADOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case UPDATE_ESTADOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case DELETE_ESTADOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case DELETE_ESTADOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case DELETE_ESTADOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        default: {
            return state
        }
    }
}